(function () {
  'use strict';
  if (window.EDGSizing) return;
  const controllers = new WeakMap();
  const all = (root, selector) => Array.from(root.querySelectorAll(selector));
  const one = (root, selector) => root.querySelector(selector);
  const put = (root, selector, value) => { const el = one(root, selector); if (el && el.textContent !== value) el.textContent = value; };
  const pretty = value => String(Number(Number(value).toFixed(3)));
  const known = root => root.dataset.edgSizingMode === 'known';
  const words = root => controllers.get(root)?.words || {};
  const positive = input => !!input && Number.isFinite(Number(input.value)) && Number(input.value) >= 1;
  const range = label => { const m = String(label).replace(/["″]/g, '').match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/); return m ? { min: Number(m[1]), max: Number(m[2]) } : null; };
  const closureRequired = root => root.hasAttribute('data-edg-standard-martingale-builder');
  const badBuckle = (root, label) => closureRequired(root) && root.dataset.closure === 'buckle' && /^(small|medium)\b/i.test(label);

  function fitState(root) {
    const w = words(root);
    if (known(root)) {
      const selected = all(root, '[data-size-choice]').find(button => button.dataset.nativeValue === root.dataset.sizeValue);
      if (!selected) return { ok: false, message: w.choose_size };
      if (closureRequired(root) && !root.dataset.closure) return { ok: false, message: w.choose_closure };
      if (badBuckle(root, root.dataset.sizeValue)) return { ok: false, message: w.buckle_limit };
      return { ok: true, message: w.known_method };
    }
    const inputs = all(root, '[data-neck], [data-head]');
    const missing = inputs.find(input => !positive(input));
    if (missing) return { ok: false, message: w.missing, field: missing };
    if (!root.dataset.sizeValue) return { ok: false, message: w.choose_size };
    if (closureRequired(root) && !root.dataset.closure) return { ok: false, message: w.choose_closure };
    if (badBuckle(root, root.dataset.sizeValue)) return { ok: false, message: w.buckle_limit };
    const neck = Number(one(root, '[data-neck]').value), headInput = one(root, '[data-head]');
    const required = headInput && root.dataset.closure !== 'buckle' ? Math.max(neck, Number(headInput.value)) : neck;
    const published = all(root, '[data-size-choice]').map(button => range(button.dataset.nativeValue)).filter(Boolean);
    if (published.length && required < Math.min(...published.map(item => item.min))) return { ok: false, message: w.mismatch };
    const limits = range(root.dataset.sizeValue);
    if (!limits) return /custom/i.test(root.dataset.sizeValue) ? { ok: true, message: w.custom } : { ok: false, message: w.choose_size };
    return required >= limits.min && required <= limits.max ? { ok: true, message: w.match } : { ok: false, message: w.mismatch };
  }

  function resetProgress(root) {
    all(root, '[data-step]').forEach(step => {
      const first = step.dataset.step === 'fit';
      step.classList.remove('is-active', 'is-complete', 'is-locked');
      step.classList.add(first ? 'is-active' : 'is-locked');
      const header = one(step, '[data-edit-step]');
      if (header) { header.disabled = !first; header.setAttribute('aria-expanded', String(first)); }
    });
    all(root, '[data-progress]').forEach(el => {
      const first = el.dataset.progress === 'fit';
      el.classList.toggle('is-active', first); el.classList.remove('is-complete');
      if (el.tagName === 'BUTTON') el.disabled = !first;
      if (first) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
    });
  }

  function syncReview(root) {
    if (!known(root)) return;
    const state = fitState(root), w = words(root);
    const feedback = one(root, '[data-edg-fit-feedback]');
    if (feedback) { feedback.textContent = state.message || ''; feedback.dataset.state = state.ok ? 'success' : 'pending'; }
    put(root, '[data-review-neck]', w.known_method);
    put(root, '[data-review-fit]', w.known_method);
    if (root.dataset.sizeValue) put(root, '[data-step-summary="fit"]', root.dataset.sizeValue);
  }

  function update(root, session) {
    if (!known(root)) {
      const neck = one(root, '[data-neck]');
      if (neck && !positive(neck)) root.dataset.neck = '';
      return false;
    }
    const controller = controllers.get(root);
    if (!controller) return false;
    const w = controller.words;
    if (closureRequired(root) && controller.closure !== root.dataset.closure) {
      controller.closure = root.dataset.closure;
      root.dataset.sizeValue = '';
      resetProgress(root);
    }
    const neck = one(root, '[data-neck]');
    root.dataset.neck = positive(neck) ? pretty(neck.value) : '';
    all(root, '[data-neck], [data-head]').forEach(input => {
      if (session?.saveMeasurement) session.saveMeasurement(input.hasAttribute('data-neck') ? 'neck' : 'head', positive(input) ? pretty(input.value) : '');
    });
    const area = one(root, '[data-size-result]');
    if (area?.hidden) area.hidden = false;
    put(root, '[data-edg-size-heading]', w.manual_title);
    put(root, '[data-size-result-label]', root.dataset.sizeValue || '');
    put(root, '[data-size-result-note]', closureRequired(root) && !root.dataset.closure ? w.choose_closure : w.manual_note + (root.dataset.closure === 'buckle' ? ' ' + w.buckle_limit : ''));
    all(root, '[data-size-choice]').forEach(button => {
      const label = button.dataset.nativeValue;
      if (button.hidden) button.hidden = false;
      button.disabled = (closureRequired(root) && !root.dataset.closure) || badBuckle(root, label);
      button.classList.remove('edg-size-primary-action');
      button.classList.toggle('is-selected', label === root.dataset.sizeValue);
      button.setAttribute('aria-pressed', String(label === root.dataset.sizeValue));
      if (button.dataset.edgManualLabel !== label) {
        button.replaceChildren();
        const strong = document.createElement('strong'), small = document.createElement('small');
        strong.textContent = label; small.textContent = w.continue;
        button.append(strong, small); button.dataset.edgManualLabel = label;
      }
      button.setAttribute('aria-label', label + '. ' + w.continue);
      delete button.dataset.edgCtaFor;
    });
    const alternates = one(root, '[data-edg-size-alt-controls]');
    if (alternates) alternates.hidden = true;
    const result = one(root, '[data-fit-result]');
    if (result) result.hidden = true;
    syncReview(root);
    return true;
  }

  function revealFit(root, input) {
    if (known(root) && input) {
      const review = one(root, '[data-step="review"]');
      if (review && !review.classList.contains('is-active')) {
        const header = one(review, '[data-edit-step]');
        if (header && !header.disabled) header.click();
      }
    } else {
      resetProgress(root);
    }
    const target = input || one(root, '[data-edg-sizing-mode="known"]');
    if (target) {
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  function validate(root) {
    const state = fitState(root);
    if (state.ok) {
      const status = one(root, '[data-status]');
      if (status) { status.textContent = ''; delete status.dataset.state; }
      return true;
    }
    const status = one(root, '[data-status]');
    if (status) { status.textContent = state.message || words(root).missing; status.dataset.state = 'error'; }
    const feedback = one(root, '[data-edg-fit-feedback]');
    if (feedback) { feedback.textContent = state.message || ''; feedback.dataset.state = 'error'; }
    if (known(root) && !state.field) {
      one(root, '[data-edg-edit-size]')?.focus({ preventScroll: true });
    } else revealFit(root, state.field);
    return false;
  }

  function mount(root, actions) {
    if (controllers.has(root)) return;
    const strings = one(root, '[data-edg-sizing-strings]');
    if (!strings) return;
    const w = JSON.parse(strings.textContent);
    const fields = one(root, '[data-edg-measure-fields]'), home = one(root, '[data-edg-measure-home]');
    const slot = one(root, '[data-edg-measure-review-slot]'), review = one(root, '[data-edg-fit-review]');
    if (!fields || !home || !slot || !review) return;
    controllers.set(root, { words: w, actions, closure: root.dataset.closure });
    root.dataset.edgSizingMode = 'guided';
    one(root, '[data-edg-construction-next]')?.addEventListener('click', () => {
      const fi = one(root, '[data-edg-fi-selector]');
      const modelChosen = fi && one(fi, '[data-edg-fi-model][aria-pressed="true"]');
      const missingModel = fi && !modelChosen && !root.dataset.nativeFiSeries && !root.dataset.fiValue && !root.dataset.nativeWidthValue;
      const missingWidth = !root.matches('[data-edg-canvas-builder]') && !root.dataset.webbingWidth;
      const target = missingModel ? one(fi, '[data-edg-fi-model]:not([hidden])') : missingWidth ? one(root, '[data-edg-fi-webbing]:not([hidden]), [data-width-choice]:not([hidden])') : null;
      if (target) {
        const message = missingModel ? w.choose_fi_model : w.choose_width;
        let error = one(root, '[data-edg-construction-field-error]');
        if (!error) {
          error = document.createElement('p'); error.dataset.edgConstructionFieldError = '';
          error.className = 'edg-construction-field-error'; error.setAttribute('role', 'alert');
          error.id = (root.id || 'edg-builder') + '-construction-error';
        }
        target.parentElement.after(error); error.textContent = message; error.hidden = false;
        target.setAttribute('aria-invalid', 'true'); target.setAttribute('aria-describedby', error.id);
        put(root, '[data-edg-construction-help]', '');
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
      const ready = actions.construction && actions.construction();
      put(root, '[data-edg-construction-help]', ready ? '' : w.choose_construction);
      if (ready) {
        const step = one(root, '[data-step].is-active');
        const heading = step && one(step, '[data-edit-step]');
        heading?.focus({ preventScroll: true });
        heading?.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
    one(root, '[data-edg-addons-next]')?.addEventListener('click', () => {
      if (!validate(root)) return;
      try { window.EDGTagReview.selected(root, true); } catch (_) { return; }
      showReview(root);
    });
    root.addEventListener('click', event => {
      if (!event.target.closest('[data-width-choice], [data-edg-fi-webbing], [data-edg-fi-model]')) return;
      const error = one(root, '[data-edg-construction-field-error]');
      if (error) error.hidden = true;
      all(root, '[data-width-choice], [data-edg-fi-webbing], [data-edg-fi-model]').forEach(button => {
        button.removeAttribute('aria-invalid'); button.removeAttribute('aria-describedby');
      });
      put(root, '[data-edg-construction-help]', '');
    });
    const colorSelect = one(root, '[data-color-select]');
    const colorButtons = all(root, '[data-edg-color-pick]');
    if (colorSelect && colorButtons.length) {
      const syncColors = () => colorButtons.forEach(button => {
        const option = Array.from(colorSelect.options).find(item => item.value === button.dataset.edgColorPick);
        button.hidden = !option || option.hidden;
        button.disabled = !option || option.disabled;
        button.setAttribute('aria-pressed', String(colorSelect.value === button.dataset.edgColorPick));
      });
      colorButtons.forEach(button => button.addEventListener('click', () => {
        if (button.disabled || button.hidden) return;
        colorSelect.value = button.dataset.edgColorPick;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncColors();
      }));
      colorSelect.addEventListener('change', syncColors);
      new MutationObserver(syncColors).observe(colorSelect, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'hidden'] });
      one(root, '[data-edg-color-native-field]').hidden = true;
      syncColors();
    }

    const switchMode = mode => {
      if (root.dataset.edgSizingMode === mode) return;
      root.dataset.edgSizingMode = mode;
      const url = new URL(window.location.href);
      if (mode === 'known') url.searchParams.set('edg_sizing', 'known'); else url.searchParams.delete('edg_sizing');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      root.dataset.sizeValue = '';
      home.appendChild(fields);
      fields.hidden = mode === 'known';
      review.hidden = true;
      all(root, '[data-edg-sizing-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.edgSizingMode === mode)));
      all(root, '[data-size-choice]').forEach(button => {
        button.disabled = false; button.classList.remove('is-selected'); button.setAttribute('aria-pressed', 'false');
        delete button.dataset.edgManualLabel; delete button.dataset.edgCtaFor;
      });
      put(root, '[data-edg-size-heading]', mode === 'known' ? w.manual_title : w.recommended);
      put(root, '[data-step-summary="fit"]', mode === 'known' ? w.manual_title : w.guided);
      resetProgress(root);
      actions.fit(); actions.review(); actions.save(); syncReview(root);
    };
    all(root, '[data-edg-sizing-mode]').forEach(button => button.addEventListener('click', () => switchMode(button.dataset.edgSizingMode)));
    one(root, '[data-edg-edit-size]')?.addEventListener('click', () => revealFit(root));
    all(root, '[data-neck], [data-head]').forEach(input => input.addEventListener('input', () => {
      if (!known(root)) return;
      queueMicrotask(() => { actions.review(); actions.save(); syncReview(root); });
    }));
    root.addEventListener('change', event => {
      if (known(root) && event.target.matches('[data-color-select], [data-pattern-select]')) queueMicrotask(() => syncReview(root));
    });
    root.addEventListener('click', event => {
      if (!known(root)) return;
      const button = event.target.closest('[data-size-choice]');
      if (button && (button.disabled || (closureRequired(root) && !root.dataset.closure))) {
        event.preventDefault(); event.stopImmediatePropagation(); return;
      }
    }, true);
    root.addEventListener('click', event => {
      if (!known(root) || !event.target.closest('[data-size-choice], [data-closure-choice], [data-edit-step], [data-color-choice], [data-pattern-choice]')) return;
      queueMicrotask(() => { update(root, window.EDGBuildSession); actions.review(); actions.save(); syncReview(root); });
    });
    if (new URLSearchParams(window.location.search).get('edg_sizing') === 'known') queueMicrotask(() => switchMode('known'));
  }

  function properties(root, source) {
    const result = Object.assign({}, source);
    if (known(root)) {
      ['Dog neck', 'Widest head', 'Required opening', 'EDG sizing measurement', 'EDG sizing basis'].forEach(key => delete result[key]);
      result['Size selection'] = words(root).known_method;
    }
    return result;
  }
  function showReview(root) {
    controllers.get(root)?.actions.review();
    syncReview(root);
    const steps = all(root, '[data-step]');
    steps.forEach(step => {
      const active = step.dataset.step === 'review';
      step.classList.remove('is-locked', 'is-active', 'is-complete');
      step.classList.add(active ? 'is-active' : 'is-complete');
      const header = one(step, '[data-edit-step]');
      if (header) { header.disabled = false; header.setAttribute('aria-expanded', String(active)); }
    });
    all(root, '[data-progress]').forEach(progress => {
      const active = progress.dataset.progress === 'review';
      progress.classList.toggle('is-active', active); progress.classList.toggle('is-complete', !active);
      if (progress.tagName === 'BUTTON') progress.disabled = false;
      if (active) progress.setAttribute('aria-current', 'step'); else progress.removeAttribute('aria-current');
    });
    window.EDGBuildCommerce?.refresh(root);
    const header = one(root, '[data-step="review"] [data-edit-step]');
    header?.focus({preventScroll:true});
    header?.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  window.EDGSizing = { showReview, mount, update, validate, fitState, isKnown: known, properties, method: root => words(root)[known(root) ? 'known_method' : 'guided_method'] || 'Size recommendation' };
})();


